module.exports = __webpack_public_path__ + "img/2011-2.446345c3.jpg";